var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from "vue-property-decorator";
import GoodService from "../../../../api/GoodService";
import AddCategroy from "./addCategroy/AddCategroy.vue";
import { EShopLinkType } from '../../../../enum/EShopLinkType';
var ImgLinkValue = (function (_super) {
    __extends(ImgLinkValue, _super);
    function ImgLinkValue() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.eShopLinkType = EShopLinkType;
        _this.deliverData = [];
        _this.dialogVisible = false;
        return _this;
    }
    ImgLinkValue.prototype.created = function () {
        this.service = GoodService.getInstance();
    };
    ImgLinkValue.prototype.handleClose = function () {
        this.dialogVisible = false;
    };
    ImgLinkValue.prototype.closeDio = function (status) {
        this.dialogVisible = status;
    };
    ImgLinkValue.prototype.saveAndClose = function (data) {
        this.dialogVisible = false;
        this.deliverData = data;
        var goods_id = [], goods_name = [];
        data.forEach(function (item) {
            goods_id.push(item.goods_id);
            goods_name.push(item.goods_name);
        });
        this.setImageItemVal(this.eShopLinkType.GOOD, goods_id.join(','), goods_name.join(','));
    };
    ImgLinkValue.prototype.openDg = function (item) {
        this.dialogVisible = true;
    };
    ImgLinkValue.prototype.setImageItemVal = function (type, id, name) {
        var imageItem = JSON.parse(JSON.stringify(this.imageItem));
        if (type == this.eShopLinkType.CATEGORY) {
            imageItem.type = this.eShopLinkType.CATEGORY;
            imageItem.relate_id_category = id;
            imageItem.relate_name_category = name;
            imageItem.relate_id_good = '';
            imageItem.relate_name_good = '';
            imageItem.front_deliver_good = this.deliverData;
        }
        else {
            imageItem.type = this.eShopLinkType.GOOD;
            imageItem.relate_id_good = id;
            imageItem.relate_name_good = name;
            imageItem.relate_id_category = '';
            imageItem.relate_name_category = '';
            imageItem.front_deliver_good = this.deliverData;
        }
        this.$emit("change", imageItem);
    };
    __decorate([
        Prop({
            type: Object
        })
    ], ImgLinkValue.prototype, "imageItem", void 0);
    __decorate([
        Prop({
            default: "",
            type: String
        })
    ], ImgLinkValue.prototype, "typeName", void 0);
    ImgLinkValue = __decorate([
        Component({
            computed: {
                inputValue: function () {
                    if (this.imageItem.relate_id_good) {
                        var selectedLen = (this.imageItem.relate_id_good && String(this.imageItem.relate_id_good).split(',').length) || 0;
                        return selectedLen > 0 ? "\u5DF2\u9009(" + selectedLen + ")" : '请选择';
                    }
                    else {
                        var originSelectedLen = (this.imageItem.relate_id && String(this.imageItem.relate_id).split(',').length) || 0;
                        return originSelectedLen > 0 ? "\u5DF2\u9009(" + originSelectedLen + ")" : '请选择';
                    }
                }
            },
            components: {
                'add-categroy': AddCategroy
            }
        })
    ], ImgLinkValue);
    return ImgLinkValue;
}(Vue));
export default ImgLinkValue;
